// need a workaround to this, cannot import browser from $app/env as of now
const isBrowser = () => typeof window !== 'undefined';
export const browser = isBrowser();
export const defaultWindow = browser ? window : undefined;
export const defaultDocument = browser ? window.document : undefined;
export const defaultNavigator = browser ? window.navigator : undefined;
export const defaultLocation = browser ? window.location : undefined;
